import { api } from "api/api";
import { AxiosError } from "axios";
import Indicador from "model/indicadores/Indicador";
import { IndicadorAnaliseColeta } from "model/indicadores/IndicadorAnaliseColeta";
import { IndicadorColeta } from "model/indicadores/IndicadorColeta";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class IndicadorMinhasAnalisesColetasService implements BaseServiceCadastros<Indicador> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {

            let url = `/indicador/minhasAnalises/pesquisar`;
            if (filters) {
                url += getFilters(filters)
            }
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    analisar(analise: IndicadorAnaliseColeta) {
        return new Promise<IndicadorAnaliseColeta>((resolve, reject): void => {
            api
                .post(`/indicador/minhasAnalises/analisar`, analise)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    buscarPorIndicador(idIndicador: number) {
        return new Promise<Indicador>((resolve, reject): void => {
            api
                .get(`/indicadorColeta/indicador/${idIndicador}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<Indicador>((resolve, reject): void => {
        });
    }

    incluir(indicador: Indicador) {
        return new Promise<Indicador>((resolve, reject): void => {
        });
    }

    editar(indicador: Indicador) {
        return new Promise<Indicador>((resolve, reject): void => {
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
        });
    }

    getStatus(status : string) {
        switch (status) {
            case 'CRIADA':
                return 'Coleta Criada';
            case 'ANALISADA':
                return 'Coleta Analisada';
            default:
                return 'Status Desconhecido';
        }
    }
}

export default IndicadorMinhasAnalisesColetasService;